import { API_TYPES } from "@clipboard-health/contract-backend-main";
import { useGetQualifications } from "@src/appV2/Admin/Qualifications/api/useGetQualifications";
import { showSuccessToast, showErrorToast } from "@src/appV2/lib/Notifications";
import { useCreateWorkerShoppableQualification } from "@src/appV2/WorkerShoppableQualifications/api/useCreateWorkerShoppableQualification";
import { Modal, Select } from "antd";
import { useState } from "react";

interface AddWorkerRoleModalParams {
  workerId: string;
  opened: boolean;
  closeModal(): void;
}

export function AddWorkerRoleModal(params: AddWorkerRoleModalParams) {
  // oxlint-disable-next-line typescript/unbound-method
  const { workerId, opened, closeModal } = params;

  const { data: { data: qualificationsData } = {}, isLoading: areQualificationsLoading } =
    useGetQualifications({
      filter: {
        enabled: true,
      },
    });

  const { mutateAsync: createRole, isLoading: isCreatingRole } =
    useCreateWorkerShoppableQualification(workerId);

  const [selectedQualificationId, setSelectedQualificationId] = useState<string>();

  const handleAddRole = async () => {
    if (!selectedQualificationId) {
      return;
    }

    try {
      await createRole({
        data: {
          type: API_TYPES.workerShoppableQualification,
          relationships: {
            qualification: {
              data: {
                type: API_TYPES.qualifications,
                id: selectedQualificationId,
              },
            },
          },
        },
      });
      showSuccessToast("Role added successfully");
      closeModal();
      setSelectedQualificationId(undefined);
      // FIXME: Automatically disabled during ESLint config update
    } catch {
      showErrorToast("Failed to add role");
    }
  };

  return (
    <Modal
      title="Add Role"
      visible={opened}
      onOk={handleAddRole}
      onCancel={() => {
        closeModal();
        setSelectedQualificationId(undefined);
      }}
      confirmLoading={isCreatingRole}
      okButtonProps={{ disabled: !selectedQualificationId || isCreatingRole }}
    >
      <Select
        style={{ width: "100%" }}
        placeholder="Select a role to add"
        onSelect={(value) => setSelectedQualificationId(value)}
        loading={areQualificationsLoading}
      >
        {qualificationsData?.map((qualification) => (
          <Select.Option
            key={qualification.id}
            value={qualification.id}
            label={qualification.attributes.displayLabel}
          >
            {qualification.attributes.displayLabel}
          </Select.Option>
        ))}
      </Select>
    </Modal>
  );
}
